export enum NameSearchMode {
  SUBSTRING = 'substring',
  REGEX = 'regex',
}
